import { VideoFeedback } from "@/enums/enums";
import { i18n } from "@/i18n";

export function GetYoutubeUrlFromPageName(urlName: string) {
  let youtubeUrlList = [];
  const addNewAssetGroup = {
    name: i18n.t("youtube_List.Add_New_Asset_Group"),
    url: "PX5ORyr-HbQ",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const deleteAssetGroup = {
    name: i18n.t("youtube_List.Delete_Asset_Group"),
    url: "BoVY0QgR02o",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const exportAssetGroup = {
    name: i18n.t("youtube_List.Export_Asset_Group"),
    url: "AC2D2zCWAMA",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const recordAssetBalance = {
    name: i18n.t("youtube_List.Record_Asset_Balance"),
    url: "R_QASBlojMM",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const deleteAssetBalance = {
    name: i18n.t("youtube_List.Delete_Asset_Balance"),
    url: "xJ8OW5r8m94",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const exportAssetReport = {
    name: i18n.t("youtube_List.Export_Asset_Report"),
    url: "roCuNHs9Ltg",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const stopDepreciation = {
    name: i18n.t("youtube_List.Stop_Depreciation"),
    url: "VW8MFo-p5Ds",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const viewAssetDetail = {
    name: i18n.t("youtube_List.View_Asset_Detail"),
    url: "bn2QeNk9qfE",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const addAssetUnit = {
    name: i18n.t("youtube_List.Add_Asset_Unit"),
    url: "Cd3q2DcAykg",
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };

  switch (urlName) {
    case "assetTemplate":
      youtubeUrlList = [addNewAssetGroup, deleteAssetGroup, exportAssetGroup];
      break;
    case "assetTemplateDetail":
      youtubeUrlList = [recordAssetBalance, deleteAssetBalance, exportAssetReport];
      break;
    case "assetDetail":
      youtubeUrlList = [stopDepreciation, viewAssetDetail];
      break;
    case "assetUnit":
      youtubeUrlList = [addAssetUnit];
      break;
    default:
      youtubeUrlList = [addNewAssetGroup, deleteAssetGroup, exportAssetGroup];
      break;
  }

  return youtubeUrlList;
}
